import React from "react";
import {
  Card,
  CardHeading,
  CardSubHeading
} from "styles/pages/web-checkout.styles";
import { FlexRow, WrapperButton, SelectRoleCTA } from "./select-role.styles";
import { Label } from "components/form-component/label/label";
import { useSelectRole } from "./use-select-role-card";
import { UserType } from "types/common/common.types";

import { useAuth } from "stores/auth/auth-context";
import { isObjectEmpty } from "utils/utils";
import { ParentStudentSelection } from "../parent-student/parent-student";

const SelectRoleCard: React.FC = (): JSX.Element => {
  const { handleChange, handleRouteChange, isSelected } = useSelectRole();

  const {
    user: {
      userData: { primary_user, parent_user }
    }
  } = useAuth();

  return (
    <Card>
      <CardHeading data-testid="profile-role-select-heading">
        {!isObjectEmpty(primary_user) && !isObjectEmpty(parent_user)
          ? "Ada bebek mandi di kali, senang kita ketemu lagi!"
          : "Buat profil baru"}
      </CardHeading>
      <CardSubHeading data-testid="profile-role-select-sub-heading">
        {!isObjectEmpty(primary_user) && !isObjectEmpty(parent_user)
          ? "Mau pakai profil yang mana hari ini?"
          : `Tak kenal maka tak sayang.  Sebelum mulai belajar di CoLearn, buat profil dulu, ya.`}
      </CardSubHeading>

      <Label id="userType">Saya Adalah...</Label>

      <FlexRow>
        <ParentStudentSelection
          userType="parent"
          heading="Orangtua"
          subHeading="Mau daftarin anak saya di CoLearn."
          isSelected={isSelected.isParent}
          onClick={() => handleChange(UserType.PARENT)}
        />

        <ParentStudentSelection
          userType="student"
          heading="Murid"
          subHeading="Aku mau belajar sama CoLearn."
          isSelected={isSelected.isStudent}
          onClick={() => handleChange(UserType.STUDENT)}
        />
      </FlexRow>

      <WrapperButton>
        <SelectRoleCTA
          disabled={!Object.values(isSelected).find((ele) => ele === true)}
          variant="primary"
          onClick={handleRouteChange}
          data-testid="user-role-next-button"
        >
          Lanjut
        </SelectRoleCTA>
      </WrapperButton>
    </Card>
  );
};

export { SelectRoleCard };
